import { Navigate, Route, Routes } from 'react-router-dom';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { DatasetProvider } from './hooks/useDataset';
import { AboutPage } from './pages/AboutPage';
import { ItineraryPage } from './pages/ItineraryPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { TrailsPage } from './pages/TrailsPage';
import { PAGES } from './site';

export function App() {
    return (
        <DatasetProvider>
            <Header />
            <main>
                <Routes>
                    {PAGES.map((page) => (
                        <Route
                            key={page.path}
                            path={page.path}
                            element={
                                page.kind === 'itinerary' ? (
                                    // key: a fresh page (selection, results) when the menu goes from one area to another
                                    <ItineraryPage key={page.path} page={page} />
                                ) : page.kind === 'trails' ? (
                                    <TrailsPage page={page} />
                                ) : (
                                    <AboutPage page={page} />
                                )
                            }
                        />
                    ))}
                    <Route path="/liste/" element={<Navigate to="/sentiers/" replace />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </main>
            <Footer />
        </DatasetProvider>
    );
}
